import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as AppConfig from "@/config/AppConfig";
import dayjs, { type Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { string, func, shape } from "prop-types";
import { formatDateYearMonthDay } from "@/utils";

dayjs.extend(utc);
dayjs.extend(timezone);

type SingleDatePickerProps = {
  componentLabel?: string;
  selectedDate?: string;
  onValueChange?: (date: Date) => void;
  user?: {
    timezone?: string;
  };
  [key: string]: unknown;
};

export const SingleDatePicker = (props: SingleDatePickerProps) => {
  let defaultSelectedYearDate = new Date();
  if (typeof props.selectedDate !== "undefined") {
    defaultSelectedYearDate = new Date(props?.selectedDate);
  }

  const selectedDateValue = formatDateYearMonthDay(defaultSelectedYearDate);
  const defaultOptions = {
    label: props.componentLabel,
    // defaultValue: dayjs(selectedDateValue),
    value: dayjs(selectedDateValue),
    format: AppConfig.dateFormat2,
  };

  const { onValueChange, user: _user, ...datePickerProps } = props;

  const selectedOptions = {
    ...defaultOptions,
    ...datePickerProps,
  };

  const dateValueChange = (event: Dayjs | null) => {
    if (event) {
      onValueChange?.(event.toDate());
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        onChange={dateValueChange}
        {...selectedOptions}
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
          },
        }}
        sx={{
          label: {
            lineHeight: 1,
          },
        }}
      />
    </LocalizationProvider>
  );
};

SingleDatePicker.propTypes = {
  componentLabel: string,
  selectedDate: string, // ISO format
  onValueChange: func,
  user: shape({
    timezone: string,
  }),
};
